export const fileTooLargeCode = 'file-too-large';
